/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type EntityActivityKind = "EDUCATIONAL" | "GOVERNMENT_AGENCY" | "NON_PROFIT" | "PARTNERSHIP" | "PRIVATELY_HELD" | "PUBLIC_COMPANY" | "SELF_EMPLOYED" | "SELF_OWNED" | "%future added value";
export type MediaAssetFileStatusKind = "AVAILABLE" | "CREATED" | "DELETED" | "ERROR" | "PROCESSING" | "%future added value";
export type MediaAssetStateKind = "AVAILABLE" | "CREATED" | "DELETED" | "PROCESSING" | "%future added value";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type SocialMediaPlatformKind = "ANGEL_LIST" | "FACEBOOK" | "INSTAGRAM" | "LINKED_IN" | "MEDIUM" | "OTHER" | "PINTEREST" | "REDDIT" | "SNAPCHAT" | "TUMBLR" | "TWITTER" | "WEIBO" | "WHATS_APP" | "YOU_TUBE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type fetchEntityQueryVariables = {
    readonly id: string;
};
export type fetchEntityQueryResponse = {
    readonly entity: {
        readonly hasErrors: boolean | null;
        readonly entity: {
            readonly __typename: string;
            readonly description: string | null;
            readonly founded: unknown | null;
            readonly id: string;
            readonly isEditable: boolean | null;
            readonly industry: string | null;
            readonly marketplace: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly story: ({
                        readonly __typename: "MarketEntryStory";
                        readonly description?: string | null;
                        readonly state?: string | null;
                        readonly id?: string;
                        readonly link?: string | null;
                        readonly peopleEntities?: ReadonlyArray<{
                            readonly entity: {
                                readonly __typename: string;
                                readonly landingPageUrl: string | null;
                                readonly id: string;
                                readonly name: string | null;
                                readonly websiteUrl: string | null;
                                readonly industry: string | null;
                                readonly fundingRound: string | null;
                                readonly activities: ReadonlyArray<{
                                    readonly kind: EntityActivityKind | null;
                                    readonly label: string | null;
                                }> | null;
                                readonly people: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly role: string | null;
                                        readonly person: {
                                            readonly __typename: string;
                                            readonly id: string;
                                            readonly fullName: string | null;
                                            readonly landingPageUrl: string | null;
                                            readonly previews: {
                                                readonly edges: ReadonlyArray<{
                                                    readonly preview: {
                                                        readonly link: string | null;
                                                        readonly kind: PreviewKind | null;
                                                        readonly mediaAsset: {
                                                            readonly files: ReadonlyArray<{
                                                                readonly name: string | null;
                                                                readonly path: string | null;
                                                            }> | null;
                                                            readonly topLevelMediaType: {
                                                                readonly kind: TopLevelMediaKind | null;
                                                            } | null;
                                                        } | null;
                                                    } | null;
                                                }> | null;
                                            } | null;
                                        };
                                    }> | null;
                                } | null;
                                readonly investmentsBy: ReadonlyArray<{
                                    readonly amount: string | null;
                                    readonly link: string | null;
                                    readonly deckUrl: string | null;
                                    readonly investmentDate: unknown | null;
                                }> | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            } | null;
                            readonly person: {
                                readonly __typename: string;
                                readonly landingPageUrl: string | null;
                                readonly id: string;
                                readonly fullName: string | null;
                                readonly responsibility: string | null;
                                readonly description: string | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            } | null;
                        }> | null;
                        readonly subTitle?: string | null;
                        readonly promoCode?: string | null;
                        readonly offerType?: string | null;
                        readonly expires?: unknown | null;
                        readonly title?: string | null;
                        readonly revision?: string | null;
                        readonly previews?: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } & ({
                        readonly __typename: "MarketEntryStory";
                        readonly description: string | null;
                        readonly state: string | null;
                        readonly id: string;
                        readonly link: string | null;
                        readonly peopleEntities: ReadonlyArray<{
                            readonly entity: {
                                readonly __typename: string;
                                readonly landingPageUrl: string | null;
                                readonly id: string;
                                readonly name: string | null;
                                readonly websiteUrl: string | null;
                                readonly industry: string | null;
                                readonly fundingRound: string | null;
                                readonly activities: ReadonlyArray<{
                                    readonly kind: EntityActivityKind | null;
                                    readonly label: string | null;
                                }> | null;
                                readonly people: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly role: string | null;
                                        readonly person: {
                                            readonly __typename: string;
                                            readonly id: string;
                                            readonly fullName: string | null;
                                            readonly landingPageUrl: string | null;
                                            readonly previews: {
                                                readonly edges: ReadonlyArray<{
                                                    readonly preview: {
                                                        readonly link: string | null;
                                                        readonly kind: PreviewKind | null;
                                                        readonly mediaAsset: {
                                                            readonly files: ReadonlyArray<{
                                                                readonly name: string | null;
                                                                readonly path: string | null;
                                                            }> | null;
                                                            readonly topLevelMediaType: {
                                                                readonly kind: TopLevelMediaKind | null;
                                                            } | null;
                                                        } | null;
                                                    } | null;
                                                }> | null;
                                            } | null;
                                        };
                                    }> | null;
                                } | null;
                                readonly investmentsBy: ReadonlyArray<{
                                    readonly amount: string | null;
                                    readonly link: string | null;
                                    readonly deckUrl: string | null;
                                    readonly investmentDate: unknown | null;
                                }> | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            } | null;
                            readonly person: {
                                readonly __typename: string;
                                readonly landingPageUrl: string | null;
                                readonly id: string;
                                readonly fullName: string | null;
                                readonly responsibility: string | null;
                                readonly description: string | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            } | null;
                        }> | null;
                        readonly subTitle: string | null;
                        readonly promoCode: string | null;
                        readonly offerType: string | null;
                        readonly expires: unknown | null;
                        readonly title: string | null;
                        readonly revision: string | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly heightInPixels: number | null;
                                            readonly widthInPixels: number | null;
                                            readonly path: string | null;
                                            readonly status: {
                                                readonly kind: MediaAssetFileStatusKind | null;
                                            } | null;
                                        }> | null;
                                        readonly state: {
                                            readonly kind: MediaAssetStateKind | null;
                                        } | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                    readonly link: string | null;
                                } | null;
                            }> | null;
                        } | null;
                    } | {
                        /*This will never be '% other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    })) | null;
                }> | null;
            } | null;
            readonly activities: ReadonlyArray<{
                readonly kind: EntityActivityKind | null;
                readonly label: string | null;
            }> | null;
            readonly isClaimable: boolean | null;
            readonly pitchOriginalMedia: {
                readonly id: string;
            } | null;
            readonly investmentsBy: ReadonlyArray<{
                readonly amount: string | null;
                readonly link: string | null;
                readonly deckUrl: string | null;
                readonly investmentDate: unknown | null;
            }> | null;
            readonly opportunities: {
                readonly productAndServices: {
                    readonly description: string | null;
                    readonly link: string | null;
                    readonly email: string | null;
                } | null;
                readonly careers: {
                    readonly description: string | null;
                    readonly link: string | null;
                    readonly email: string | null;
                } | null;
                readonly collaboration: {
                    readonly description: string | null;
                    readonly link: string | null;
                    readonly email: string | null;
                } | null;
            } | null;
            readonly fundingRound: string | null;
            readonly isFundraising: boolean | null;
            readonly isFeedBaseEntity: boolean | null;
            readonly landingPageUrl: string | null;
            readonly locations: ReadonlyArray<{
                readonly id: string | null;
                readonly label: string | null;
            }> | null;
            readonly headquarters: {
                readonly location: {
                    readonly label: string | null;
                } | null;
            } | null;
            readonly feed: {
                readonly feed: ReadonlyArray<{
                    readonly key: string;
                    readonly stories: ReadonlyArray<{
                        readonly __typename: string;
                        readonly id?: string;
                        readonly link?: string | null;
                        readonly title?: string | null;
                        readonly kind?: string | null;
                        readonly publisher?: string | null;
                        readonly publishedDate?: unknown | null;
                        readonly timeToReadInSeconds?: number | null;
                        readonly previews?: {
                            readonly edges: ReadonlyArray<{
                                readonly preview: {
                                    readonly link: string | null;
                                    readonly kind: PreviewKind | null;
                                } | null;
                            }> | null;
                        } | null;
                        readonly description?: string | null;
                    } & ({
                        readonly __typename: "RadivisionPost";
                        readonly id: string;
                        readonly link: string | null;
                        readonly title: string | null;
                    } | {
                        readonly __typename: "ArticleStory";
                        readonly kind: string | null;
                        readonly publisher: string | null;
                        readonly publishedDate: unknown | null;
                        readonly timeToReadInSeconds: number | null;
                        readonly previews: {
                            readonly edges: ReadonlyArray<{
                                readonly preview: {
                                    readonly link: string | null;
                                    readonly kind: PreviewKind | null;
                                } | null;
                            }> | null;
                        } | null;
                        readonly description: string | null;
                    } | {
                        /*This will never be '% other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    })> | null;
                }> | null;
            } | null;
            readonly mediaAbout: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly story: ({
                        readonly __typename: string;
                        readonly id?: string;
                        readonly link?: string | null;
                        readonly previews?: {
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly link: string | null;
                                    readonly kind: PreviewKind | null;
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly path: string | null;
                                        }> | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                            readonly label: string | null;
                                        } | null;
                                    } | null;
                                } | null;
                            }> | null;
                            readonly count: number | null;
                        } | null;
                        readonly subTitle?: string | null;
                        readonly title?: string | null;
                        readonly description?: string | null;
                        readonly landingPageUrl?: string | null;
                        readonly revision?: string | null;
                        readonly content?: string | null;
                        readonly publishedDate?: unknown | null;
                        readonly timeRequiredInSeconds?: number | null;
                        readonly publisher?: string | null;
                        readonly timeToReadInSeconds?: number | null;
                        readonly durationInSeconds?: number | null;
                    } & ({
                        readonly __typename: "RadivisionPost";
                        readonly id: string;
                        readonly link: string | null;
                        readonly previews: {
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly link: string | null;
                                    readonly kind: PreviewKind | null;
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly path: string | null;
                                        }> | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                            readonly label: string | null;
                                        } | null;
                                    } | null;
                                } | null;
                            }> | null;
                            readonly count: number | null;
                        } | null;
                        readonly subTitle: string | null;
                        readonly title: string | null;
                        readonly description: string | null;
                        readonly landingPageUrl: string | null;
                        readonly revision: string | null;
                        readonly content: string | null;
                    } | {
                        readonly __typename: "OnlineCourseStory";
                        readonly publishedDate: unknown | null;
                        readonly timeRequiredInSeconds: number | null;
                        readonly publisher: string | null;
                    } | {
                        readonly __typename: "ArticleStory";
                        readonly timeToReadInSeconds: number | null;
                    } | {
                        readonly __typename: "PodcastStory";
                        readonly durationInSeconds: number | null;
                    } | {
                        /*This will never be '% other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    })) | null;
                }> | null;
            } | null;
            readonly name: string | null;
            readonly hasPortfolio: boolean | null;
            readonly portfolioMarketCap: string | null;
            readonly portfolioEntities: {
                readonly id: string;
            } | null;
            readonly portfolioPeople: {
                readonly id: string;
            } | null;
            readonly noOfPortfolioCompanies: {
                readonly maximum: number | null;
                readonly minimum: number | null;
                readonly isGreaterThan: boolean | null;
                readonly isLessThan: boolean | null;
            } | null;
            readonly portfolio: {
                readonly count: number | null;
                readonly pageInfo: {
                    readonly hasNextPage: boolean | null;
                } | null;
                readonly edges: ReadonlyArray<{
                    readonly edges: {
                        readonly __typename: string;
                        readonly id: string;
                        readonly name: string | null;
                        readonly landingPageUrl: string | null;
                        readonly previews: {
                            readonly edges: ReadonlyArray<{
                                readonly preview: {
                                    readonly link: string | null;
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly name: string | null;
                                            readonly path: string | null;
                                        }> | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                        } | null;
                                    } | null;
                                    readonly kind: PreviewKind | null;
                                } | null;
                            }> | null;
                        } | null;
                        readonly tags: ReadonlyArray<{
                            readonly label: string | null;
                        }> | null;
                    } | null;
                }> | null;
            } | null;
            readonly noOfEmployees: {
                readonly maximum: number | null;
                readonly minimum: number | null;
                readonly isGreaterThan: boolean | null;
                readonly isLessThan: boolean | null;
            } | null;
            readonly people: {
                readonly count: number | null;
                readonly pageInfo: {
                    readonly hasNextPage: boolean | null;
                } | null;
                readonly edges: ReadonlyArray<{
                    readonly role: string | null;
                    readonly person: {
                        readonly id: string;
                        readonly __typename: string;
                        readonly fullName: string | null;
                        readonly responsibility: string | null;
                        readonly description: string | null;
                        readonly landingPageUrl: string | null;
                        readonly previews: {
                            readonly count: number | null;
                            readonly edges: ReadonlyArray<{
                                readonly cursor: string | null;
                                readonly preview: {
                                    readonly link: string | null;
                                    readonly kind: PreviewKind | null;
                                    readonly mediaAsset: {
                                        readonly id: string;
                                        readonly files: ReadonlyArray<{
                                            readonly id: string;
                                            readonly name: string | null;
                                            readonly path: string | null;
                                        }> | null;
                                        readonly topLevelMediaType: {
                                            readonly kind: TopLevelMediaKind | null;
                                            readonly label: string | null;
                                        } | null;
                                    } | null;
                                } | null;
                            }> | null;
                        } | null;
                    };
                }> | null;
            } | null;
            readonly previews: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly preview: {
                        readonly link: string | null;
                        readonly kind: PreviewKind | null;
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly path: string | null;
                            }> | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                                readonly label: string | null;
                            } | null;
                        } | null;
                    } | null;
                }> | null;
            } | null;
            readonly northStar: {
                readonly __typename: string;
                readonly description: string | null;
                readonly id: string;
                readonly questions: ReadonlyArray<{
                    readonly __typename: string;
                    readonly content?: string | null;
                    readonly id?: string;
                    readonly response?: {
                        readonly content: string | null;
                        readonly id: string;
                    } | null;
                } & ({
                    readonly __typename: "TextQuestion";
                    readonly content: string | null;
                    readonly id: string;
                    readonly response: {
                        readonly content: string | null;
                        readonly id: string;
                    } | null;
                } | {
                    /*This will never be '% other', but we need some
                    value in case none of the concrete values match.*/
                    readonly __typename: "%other";
                })> | null;
            } | null;
            readonly tagLine: string | null;
            readonly mission: string | null;
            readonly country: string | null;
            readonly spotlights: ReadonlyArray<string> | null;
            readonly socialMediaCredentials: ReadonlyArray<{
                readonly credential: string | null;
                readonly platform: {
                    readonly kind: SocialMediaPlatformKind | null;
                };
            }> | null;
            readonly socialMediaProfiles: ReadonlyArray<{
                readonly id: string;
                readonly link: string | null;
                readonly platform: {
                    readonly id: string;
                    readonly kind: SocialMediaPlatformKind | null;
                } | null;
            }> | null;
            readonly revision: string | null;
            readonly websiteUrl: string | null;
        } | null;
    } | null;
};
export type fetchEntityQuery = {
    readonly response: fetchEntityQueryResponse;
    readonly variables: fetchEntityQueryVariables;
};



/*
query fetchEntityQuery(
  $id: ID!
) {
  entity(id: $id) {
    hasErrors
    entity {
      __typename
      description
      founded
      id
      isEditable
      industry
      marketplace {
        count
        edges {
          cursor
          story {
            __typename
            ... on MarketEntryStory {
              __typename
              description
              state
              id
              link
              peopleEntities {
                entity {
                  __typename
                  landingPageUrl
                  id
                  name
                  websiteUrl
                  industry
                  fundingRound
                  activities {
                    kind
                    label
                    id
                  }
                  people {
                    count
                    edges {
                      role
                      person {
                        __typename
                        id
                        fullName
                        landingPageUrl
                        previews {
                          edges {
                            preview {
                              link
                              kind
                              mediaAsset {
                                files {
                                  name
                                  path
                                  id
                                }
                                topLevelMediaType {
                                  kind
                                  id
                                }
                                id
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  investmentsBy {
                    amount
                    link
                    deckUrl
                    investmentDate
                    id
                  }
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        mediaAsset {
                          id
                          files {
                            id
                            name
                            heightInPixels
                            widthInPixels
                            path
                            status {
                              kind
                              id
                            }
                          }
                          state {
                            kind
                            id
                          }
                          topLevelMediaType {
                            kind
                            id
                          }
                        }
                        kind
                        link
                      }
                    }
                  }
                }
                person {
                  __typename
                  landingPageUrl
                  id
                  fullName
                  responsibility
                  description
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        mediaAsset {
                          id
                          files {
                            id
                            name
                            heightInPixels
                            widthInPixels
                            path
                            status {
                              kind
                              id
                            }
                          }
                          state {
                            kind
                            id
                          }
                          topLevelMediaType {
                            kind
                            id
                          }
                        }
                        kind
                        link
                      }
                    }
                  }
                }
              }
              subTitle
              promoCode
              offerType
              expires
              title
              revision
              previews {
                count
                edges {
                  cursor
                  preview {
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        heightInPixels
                        widthInPixels
                        path
                        status {
                          kind
                          id
                        }
                      }
                      state {
                        kind
                        id
                      }
                      topLevelMediaType {
                        kind
                        id
                      }
                    }
                    kind
                    link
                  }
                }
              }
            }
            ... on Node {
              id
            }
          }
        }
      }
      activities {
        kind
        label
        id
      }
      isClaimable
      pitchOriginalMedia {
        id
      }
      investmentsBy {
        amount
        link
        deckUrl
        investmentDate
        id
      }
      opportunities {
        productAndServices {
          description
          link
          email
        }
        careers {
          description
          link
          email
        }
        collaboration {
          description
          link
          email
        }
        id
      }
      fundingRound
      isFundraising
      isFeedBaseEntity
      landingPageUrl
      locations {
        id
        label
      }
      headquarters {
        location {
          label
          id
        }
        id
      }
      feed(kind: PROFILE) {
        feed {
          key
          stories {
            __typename
            ... on RadivisionPost {
              id
              link
              title
            }
            ... on ArticleStory {
              id
              link
              kind
              publisher
              publishedDate
              timeToReadInSeconds
              previews {
                edges {
                  preview {
                    link
                    kind
                  }
                }
              }
              description
              title
            }
            ... on Node {
              id
            }
          }
        }
      }
      mediaAbout {
        count
        edges {
          cursor
          story {
            __typename
            ... on RadivisionPost {
              id
              link
              previews {
                edges {
                  cursor
                  preview {
                    link
                    kind
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                    }
                  }
                }
                count
              }
              subTitle
              title
              description
              landingPageUrl
              revision
              content
            }
            ... on OnlineCourseStory {
              id
              publishedDate
              timeRequiredInSeconds
              publisher
              link
              previews {
                edges {
                  cursor
                  preview {
                    link
                    kind
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                    }
                  }
                }
              }
              subTitle
              title
              description
              revision
            }
            ... on ArticleStory {
              description
              id
              link
              publisher
              publishedDate
              timeToReadInSeconds
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    kind
                    mediaAsset {
                      id
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                    }
                  }
                }
              }
              revision
              subTitle
              title
            }
            ... on BookStory {
              id
              link
              publisher
              publishedDate
              timeToReadInSeconds
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    kind
                    mediaAsset {
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                      id
                    }
                  }
                }
              }
              subTitle
              title
              description
              revision
            }
            ... on NewsletterStory {
              id
              description
              link
              publisher
              publishedDate
              timeToReadInSeconds
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    kind
                    mediaAsset {
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                      id
                    }
                  }
                }
              }
              subTitle
              title
              revision
            }
            ... on PodcastStory {
              id
              link
              publisher
              publishedDate
              durationInSeconds
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    kind
                    mediaAsset {
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                      id
                    }
                  }
                }
              }
              subTitle
              title
              description
              revision
            }
            ... on OriginalContentStory {
              id
              durationInSeconds
              previews {
                count
                edges {
                  cursor
                  preview {
                    link
                    kind
                    mediaAsset {
                      files {
                        id
                        name
                        path
                      }
                      topLevelMediaType {
                        kind
                        label
                        id
                      }
                      id
                    }
                  }
                }
              }
              subTitle
              title
              revision
            }
            ... on Node {
              id
            }
          }
        }
      }
      name
      hasPortfolio
      portfolioMarketCap
      portfolioEntities {
        id
      }
      portfolioPeople {
        id
      }
      noOfPortfolioCompanies {
        maximum
        minimum
        isGreaterThan
        isLessThan
      }
      portfolio {
        count
        pageInfo {
          hasNextPage
        }
        edges {
          edges {
            __typename
            id
            name
            landingPageUrl
            previews(kinds: [SQUARE, LOGO]) {
              edges {
                preview {
                  link
                  mediaAsset {
                    id
                    files {
                      name
                      path
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                }
              }
            }
            tags {
              label
              id
            }
          }
        }
      }
      noOfEmployees {
        maximum
        minimum
        isGreaterThan
        isLessThan
      }
      people(first: 24) {
        count
        pageInfo {
          hasNextPage
        }
        edges {
          role
          person {
            id
            __typename
            fullName
            responsibility
            description
            landingPageUrl
            previews {
              count
              edges {
                cursor
                preview {
                  link
                  kind
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      path
                    }
                    topLevelMediaType {
                      kind
                      label
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      previews {
        count
        edges {
          cursor
          preview {
            link
            kind
            mediaAsset {
              id
              files {
                id
                name
                path
              }
              topLevelMediaType {
                kind
                label
                id
              }
            }
          }
        }
      }
      northStar {
        __typename
        description
        id
        questions {
          __typename
          ... on TextQuestion {
            content
            id
            response {
              content
              id
            }
          }
          ... on MultipleChoiceQuestion {
            id
          }
        }
      }
      tagLine
      mission
      country
      spotlights
      socialMediaCredentials {
        credential
        platform {
          kind
          id
        }
        id
      }
      socialMediaProfiles {
        id
        link
        platform {
          id
          kind
        }
      }
      revision
      websiteUrl
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "founded",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isEditable",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "industry",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "websiteUrl",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fundingRound",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v19 = [
  (v17/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "activities",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityActivity",
  "plural": true,
  "selections": (v19/*: any*/)
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "role",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v23/*: any*/)
  ]
},
v25 = [
  (v17/*: any*/)
],
v26 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": (v25/*: any*/)
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "deckUrl",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "investmentDate",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "investmentsBy",
  "storageKey": null,
  "args": null,
  "concreteType": "Investment",
  "plural": true,
  "selections": [
    (v27/*: any*/),
    (v12/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/)
  ]
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "heightInPixels",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "widthInPixels",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v6/*: any*/),
                    (v14/*: any*/),
                    (v31/*: any*/),
                    (v32/*: any*/),
                    (v23/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v25/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v25/*: any*/)
                },
                (v26/*: any*/)
              ]
            },
            (v17/*: any*/),
            (v12/*: any*/)
          ]
        }
      ]
    }
  ]
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "promoCode",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "offerType",
  "args": null,
  "storageKey": null
},
v38 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expires",
  "args": null,
  "storageKey": null
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isClaimable",
  "args": null,
  "storageKey": null
},
v42 = [
  (v6/*: any*/)
],
v43 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pitchOriginalMedia",
  "storageKey": null,
  "args": null,
  "concreteType": "PitchVideoStory",
  "plural": false,
  "selections": (v42/*: any*/)
},
v44 = [
  (v4/*: any*/),
  (v12/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  }
],
v45 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "productAndServices",
  "storageKey": null,
  "args": null,
  "concreteType": "OpportunitiesItem",
  "plural": false,
  "selections": (v44/*: any*/)
},
v46 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "careers",
  "storageKey": null,
  "args": null,
  "concreteType": "OpportunitiesItem",
  "plural": false,
  "selections": (v44/*: any*/)
},
v47 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "collaboration",
  "storageKey": null,
  "args": null,
  "concreteType": "OpportunitiesItem",
  "plural": false,
  "selections": (v44/*: any*/)
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isFundraising",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isFeedBaseEntity",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "locations",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityLocation",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v18/*: any*/)
  ]
},
v51 = [
  (v18/*: any*/)
],
v52 = [
  {
    "kind": "Literal",
    "name": "kind",
    "value": "PROFILE"
  }
],
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publisher",
  "args": null,
  "storageKey": null
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishedDate",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeToReadInSeconds",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            (v17/*: any*/)
          ]
        }
      ]
    }
  ]
},
v58 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v14/*: any*/),
    (v23/*: any*/)
  ]
},
v59 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": (v19/*: any*/)
},
v60 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "edges",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewEdge",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preview",
      "storageKey": null,
      "args": null,
      "concreteType": "Preview",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v17/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "mediaAsset",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaAsset",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v58/*: any*/),
            (v59/*: any*/)
          ]
        }
      ]
    }
  ]
},
v61 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "content",
  "args": null,
  "storageKey": null
},
v62 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeRequiredInSeconds",
  "args": null,
  "storageKey": null
},
v63 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v60/*: any*/)
  ]
},
v64 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            (v17/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v58/*: any*/),
                (v59/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v65 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "durationInSeconds",
  "args": null,
  "storageKey": null
},
v66 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPortfolio",
  "args": null,
  "storageKey": null
},
v67 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "portfolioMarketCap",
  "args": null,
  "storageKey": null
},
v68 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolioEntities",
  "storageKey": null,
  "args": null,
  "concreteType": "ListCollection",
  "plural": false,
  "selections": (v42/*: any*/)
},
v69 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolioPeople",
  "storageKey": null,
  "args": null,
  "concreteType": "ListCollection",
  "plural": false,
  "selections": (v42/*: any*/)
},
v70 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "maximum",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "minimum",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isGreaterThan",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isLessThan",
    "args": null,
    "storageKey": null
  }
],
v71 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "noOfPortfolioCompanies",
  "storageKey": null,
  "args": null,
  "concreteType": "Range",
  "plural": false,
  "selections": (v70/*: any*/)
},
v72 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v73 = [
  {
    "kind": "Literal",
    "name": "kinds",
    "value": [
      "SQUARE",
      "LOGO"
    ]
  }
],
v74 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "noOfEmployees",
  "storageKey": null,
  "args": null,
  "concreteType": "Range",
  "plural": false,
  "selections": (v70/*: any*/)
},
v75 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 24
  }
],
v76 = {
  "kind": "InlineFragment",
  "type": "TextQuestion",
  "selections": [
    (v61/*: any*/),
    (v6/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "response",
      "storageKey": null,
      "args": null,
      "concreteType": "TextQuestionResponse",
      "plural": false,
      "selections": [
        (v61/*: any*/),
        (v6/*: any*/)
      ]
    }
  ]
},
v77 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tagLine",
  "args": null,
  "storageKey": null
},
v78 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mission",
  "args": null,
  "storageKey": null
},
v79 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "country",
  "args": null,
  "storageKey": null
},
v80 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "spotlights",
  "args": null,
  "storageKey": null
},
v81 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "credential",
  "args": null,
  "storageKey": null
},
v82 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "socialMediaProfiles",
  "storageKey": null,
  "args": null,
  "concreteType": "SocialMediaProfile",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v12/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "platform",
      "storageKey": null,
      "args": null,
      "concreteType": "SocialMediaPlatform",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v17/*: any*/)
      ]
    }
  ]
},
v83 = [
  (v17/*: any*/),
  (v18/*: any*/),
  (v6/*: any*/)
],
v84 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "activities",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityActivity",
  "plural": true,
  "selections": (v83/*: any*/)
},
v85 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v23/*: any*/),
    (v6/*: any*/)
  ]
},
v86 = [
  (v17/*: any*/),
  (v6/*: any*/)
],
v87 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": (v86/*: any*/)
},
v88 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "investmentsBy",
  "storageKey": null,
  "args": null,
  "concreteType": "Investment",
  "plural": true,
  "selections": [
    (v27/*: any*/),
    (v12/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v6/*: any*/)
  ]
},
v89 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v6/*: any*/),
                    (v14/*: any*/),
                    (v31/*: any*/),
                    (v32/*: any*/),
                    (v23/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v86/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v86/*: any*/)
                },
                (v87/*: any*/)
              ]
            },
            (v17/*: any*/),
            (v12/*: any*/)
          ]
        }
      ]
    }
  ]
},
v90 = [
  (v18/*: any*/),
  (v6/*: any*/)
],
v91 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": (v83/*: any*/)
},
v92 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "edges",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewEdge",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preview",
      "storageKey": null,
      "args": null,
      "concreteType": "Preview",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v17/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "mediaAsset",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaAsset",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v58/*: any*/),
            (v91/*: any*/)
          ]
        }
      ]
    }
  ]
},
v93 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v92/*: any*/)
  ]
},
v94 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            (v17/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v58/*: any*/),
                (v91/*: any*/),
                (v6/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "fetchEntityQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "entity",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "EntityPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "entity",
            "storageKey": null,
            "args": null,
            "concreteType": "Entity",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "marketplace",
                "storageKey": null,
                "args": null,
                "concreteType": "StoriesConnection",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryEdge",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "story",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "type": "MarketEntryStory",
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v11/*: any*/),
                              (v6/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "peopleEntities",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "EntityPerson",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entity",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Entity",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v13/*: any*/),
                                      (v6/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v8/*: any*/),
                                      (v16/*: any*/),
                                      (v20/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "people",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "EntityOwnersConnection",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "EntityOwner",
                                            "plural": true,
                                            "selections": [
                                              (v21/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "person",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Person",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  (v6/*: any*/),
                                                  (v22/*: any*/),
                                                  (v13/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "previews",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PreviewsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "edges",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "PreviewEdge",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "preview",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Preview",
                                                            "plural": false,
                                                            "selections": [
                                                              (v12/*: any*/),
                                                              (v17/*: any*/),
                                                              {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "mediaAsset",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "MediaAsset",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v24/*: any*/),
                                                                  (v26/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v30/*: any*/),
                                      (v33/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "person",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Person",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v13/*: any*/),
                                      (v6/*: any*/),
                                      (v22/*: any*/),
                                      (v34/*: any*/),
                                      (v4/*: any*/),
                                      (v33/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/),
                              (v33/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v20/*: any*/),
              (v41/*: any*/),
              (v43/*: any*/),
              (v30/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "opportunities",
                "storageKey": null,
                "args": null,
                "concreteType": "Opportunities",
                "plural": false,
                "selections": [
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/)
                ]
              },
              (v16/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v13/*: any*/),
              (v50/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "headquarters",
                "storageKey": null,
                "args": null,
                "concreteType": "Contact",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "location",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "GeographicalLocation",
                    "plural": false,
                    "selections": (v51/*: any*/)
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "feed",
                "storageKey": "feed(kind:\"PROFILE\")",
                "args": (v52/*: any*/),
                "concreteType": "FeedConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "feed",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FeedItem",
                    "plural": true,
                    "selections": [
                      (v53/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "stories",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "RadivisionPost",
                            "selections": [
                              (v6/*: any*/),
                              (v12/*: any*/),
                              (v39/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "ArticleStory",
                            "selections": [
                              (v6/*: any*/),
                              (v12/*: any*/),
                              (v17/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/),
                              (v4/*: any*/),
                              (v39/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaAbout",
                "storageKey": null,
                "args": null,
                "concreteType": "StoriesConnection",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryEdge",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "story",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "RadivisionPost",
                            "selections": [
                              (v6/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "previews",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PreviewsConnection",
                                "plural": false,
                                "selections": [
                                  (v60/*: any*/),
                                  (v9/*: any*/)
                                ]
                              },
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v4/*: any*/),
                              (v13/*: any*/),
                              (v40/*: any*/),
                              (v61/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "OnlineCourseStory",
                            "selections": [
                              (v6/*: any*/),
                              (v55/*: any*/),
                              (v62/*: any*/),
                              (v54/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "previews",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PreviewsConnection",
                                "plural": false,
                                "selections": [
                                  (v60/*: any*/)
                                ]
                              },
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v4/*: any*/),
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "ArticleStory",
                            "selections": [
                              (v4/*: any*/),
                              (v6/*: any*/),
                              (v12/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v63/*: any*/),
                              (v40/*: any*/),
                              (v35/*: any*/),
                              (v39/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "BookStory",
                            "selections": [
                              (v6/*: any*/),
                              (v12/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v64/*: any*/),
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v4/*: any*/),
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "NewsletterStory",
                            "selections": [
                              (v6/*: any*/),
                              (v4/*: any*/),
                              (v12/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v64/*: any*/),
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "PodcastStory",
                            "selections": [
                              (v6/*: any*/),
                              (v12/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v65/*: any*/),
                              (v64/*: any*/),
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v4/*: any*/),
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "OriginalContentStory",
                            "selections": [
                              (v6/*: any*/),
                              (v65/*: any*/),
                              (v64/*: any*/),
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v71/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "portfolio",
                "storageKey": null,
                "args": null,
                "concreteType": "EntitiesConnection",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v72/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EntityEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Entity",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v14/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "previews",
                            "storageKey": "previews(kinds:[\"SQUARE\",\"LOGO\"])",
                            "args": (v73/*: any*/),
                            "concreteType": "PreviewsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PreviewEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "preview",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Preview",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "mediaAsset",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "MediaAsset",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v24/*: any*/),
                                          (v26/*: any*/)
                                        ]
                                      },
                                      (v17/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "tags",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Tag",
                            "plural": true,
                            "selections": (v51/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v74/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "people",
                "storageKey": "people(first:24)",
                "args": (v75/*: any*/),
                "concreteType": "EntityOwnersConnection",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v72/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EntityOwner",
                    "plural": true,
                    "selections": [
                      (v21/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "person",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Person",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v3/*: any*/),
                          (v22/*: any*/),
                          (v34/*: any*/),
                          (v4/*: any*/),
                          (v13/*: any*/),
                          (v63/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v63/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "northStar",
                "storageKey": null,
                "args": null,
                "concreteType": "Questionnaire",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "questions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v76/*: any*/)
                    ]
                  }
                ]
              },
              (v77/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "socialMediaCredentials",
                "storageKey": null,
                "args": null,
                "concreteType": "SocialMediaCredential",
                "plural": true,
                "selections": [
                  (v81/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "platform",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SocialMediaPlatform",
                    "plural": false,
                    "selections": (v25/*: any*/)
                  }
                ]
              },
              (v82/*: any*/),
              (v40/*: any*/),
              (v15/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "fetchEntityQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "entity",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "EntityPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "entity",
            "storageKey": null,
            "args": null,
            "concreteType": "Entity",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "marketplace",
                "storageKey": null,
                "args": null,
                "concreteType": "StoriesConnection",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryEdge",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "story",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "MarketEntryStory",
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "peopleEntities",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "EntityPerson",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entity",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Entity",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v13/*: any*/),
                                      (v6/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v8/*: any*/),
                                      (v16/*: any*/),
                                      (v84/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "people",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "EntityOwnersConnection",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "EntityOwner",
                                            "plural": true,
                                            "selections": [
                                              (v21/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "person",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Person",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  (v6/*: any*/),
                                                  (v22/*: any*/),
                                                  (v13/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "previews",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PreviewsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "edges",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "PreviewEdge",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "preview",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Preview",
                                                            "plural": false,
                                                            "selections": [
                                                              (v12/*: any*/),
                                                              (v17/*: any*/),
                                                              {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "mediaAsset",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "MediaAsset",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v85/*: any*/),
                                                                  (v87/*: any*/),
                                                                  (v6/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v88/*: any*/),
                                      (v89/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "person",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Person",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v13/*: any*/),
                                      (v6/*: any*/),
                                      (v22/*: any*/),
                                      (v34/*: any*/),
                                      (v4/*: any*/),
                                      (v89/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/),
                              (v89/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v84/*: any*/),
              (v41/*: any*/),
              (v43/*: any*/),
              (v88/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "opportunities",
                "storageKey": null,
                "args": null,
                "concreteType": "Opportunities",
                "plural": false,
                "selections": [
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v6/*: any*/)
                ]
              },
              (v16/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v13/*: any*/),
              (v50/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "headquarters",
                "storageKey": null,
                "args": null,
                "concreteType": "Contact",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "location",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "GeographicalLocation",
                    "plural": false,
                    "selections": (v90/*: any*/)
                  },
                  (v6/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "feed",
                "storageKey": "feed(kind:\"PROFILE\")",
                "args": (v52/*: any*/),
                "concreteType": "FeedConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "feed",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FeedItem",
                    "plural": true,
                    "selections": [
                      (v53/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "stories",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "RadivisionPost",
                            "selections": [
                              (v12/*: any*/),
                              (v39/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "ArticleStory",
                            "selections": [
                              (v12/*: any*/),
                              (v17/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/),
                              (v4/*: any*/),
                              (v39/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaAbout",
                "storageKey": null,
                "args": null,
                "concreteType": "StoriesConnection",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryEdge",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "story",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "RadivisionPost",
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "previews",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PreviewsConnection",
                                "plural": false,
                                "selections": [
                                  (v92/*: any*/),
                                  (v9/*: any*/)
                                ]
                              },
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v4/*: any*/),
                              (v13/*: any*/),
                              (v40/*: any*/),
                              (v61/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "OnlineCourseStory",
                            "selections": [
                              (v55/*: any*/),
                              (v62/*: any*/),
                              (v54/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "previews",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PreviewsConnection",
                                "plural": false,
                                "selections": [
                                  (v92/*: any*/)
                                ]
                              },
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v4/*: any*/),
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "ArticleStory",
                            "selections": [
                              (v4/*: any*/),
                              (v12/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v93/*: any*/),
                              (v40/*: any*/),
                              (v35/*: any*/),
                              (v39/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "BookStory",
                            "selections": [
                              (v12/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v94/*: any*/),
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v4/*: any*/),
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "NewsletterStory",
                            "selections": [
                              (v4/*: any*/),
                              (v12/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v94/*: any*/),
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "PodcastStory",
                            "selections": [
                              (v12/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v65/*: any*/),
                              (v94/*: any*/),
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v4/*: any*/),
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "OriginalContentStory",
                            "selections": [
                              (v65/*: any*/),
                              (v94/*: any*/),
                              (v35/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v71/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "portfolio",
                "storageKey": null,
                "args": null,
                "concreteType": "EntitiesConnection",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v72/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EntityEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Entity",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v14/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "previews",
                            "storageKey": "previews(kinds:[\"SQUARE\",\"LOGO\"])",
                            "args": (v73/*: any*/),
                            "concreteType": "PreviewsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PreviewEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "preview",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Preview",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "mediaAsset",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "MediaAsset",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v85/*: any*/),
                                          (v87/*: any*/)
                                        ]
                                      },
                                      (v17/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "tags",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Tag",
                            "plural": true,
                            "selections": (v90/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v74/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "people",
                "storageKey": "people(first:24)",
                "args": (v75/*: any*/),
                "concreteType": "EntityOwnersConnection",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v72/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EntityOwner",
                    "plural": true,
                    "selections": [
                      (v21/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "person",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Person",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v3/*: any*/),
                          (v22/*: any*/),
                          (v34/*: any*/),
                          (v4/*: any*/),
                          (v13/*: any*/),
                          (v93/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v93/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "northStar",
                "storageKey": null,
                "args": null,
                "concreteType": "Questionnaire",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "questions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v76/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "MultipleChoiceQuestion",
                        "selections": (v42/*: any*/)
                      }
                    ]
                  }
                ]
              },
              (v77/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "socialMediaCredentials",
                "storageKey": null,
                "args": null,
                "concreteType": "SocialMediaCredential",
                "plural": true,
                "selections": [
                  (v81/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "platform",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SocialMediaPlatform",
                    "plural": false,
                    "selections": (v86/*: any*/)
                  },
                  (v6/*: any*/)
                ]
              },
              (v82/*: any*/),
              (v40/*: any*/),
              (v15/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "fetchEntityQuery",
    "id": null,
    "text": "query fetchEntityQuery(\n  $id: ID!\n) {\n  entity(id: $id) {\n    hasErrors\n    entity {\n      __typename\n      description\n      founded\n      id\n      isEditable\n      industry\n      marketplace {\n        count\n        edges {\n          cursor\n          story {\n            __typename\n            ... on MarketEntryStory {\n              __typename\n              description\n              state\n              id\n              link\n              peopleEntities {\n                entity {\n                  __typename\n                  landingPageUrl\n                  id\n                  name\n                  websiteUrl\n                  industry\n                  fundingRound\n                  activities {\n                    kind\n                    label\n                    id\n                  }\n                  people {\n                    count\n                    edges {\n                      role\n                      person {\n                        __typename\n                        id\n                        fullName\n                        landingPageUrl\n                        previews {\n                          edges {\n                            preview {\n                              link\n                              kind\n                              mediaAsset {\n                                files {\n                                  name\n                                  path\n                                  id\n                                }\n                                topLevelMediaType {\n                                  kind\n                                  id\n                                }\n                                id\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                  investmentsBy {\n                    amount\n                    link\n                    deckUrl\n                    investmentDate\n                    id\n                  }\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        mediaAsset {\n                          id\n                          files {\n                            id\n                            name\n                            heightInPixels\n                            widthInPixels\n                            path\n                            status {\n                              kind\n                              id\n                            }\n                          }\n                          state {\n                            kind\n                            id\n                          }\n                          topLevelMediaType {\n                            kind\n                            id\n                          }\n                        }\n                        kind\n                        link\n                      }\n                    }\n                  }\n                }\n                person {\n                  __typename\n                  landingPageUrl\n                  id\n                  fullName\n                  responsibility\n                  description\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        mediaAsset {\n                          id\n                          files {\n                            id\n                            name\n                            heightInPixels\n                            widthInPixels\n                            path\n                            status {\n                              kind\n                              id\n                            }\n                          }\n                          state {\n                            kind\n                            id\n                          }\n                          topLevelMediaType {\n                            kind\n                            id\n                          }\n                        }\n                        kind\n                        link\n                      }\n                    }\n                  }\n                }\n              }\n              subTitle\n              promoCode\n              offerType\n              expires\n              title\n              revision\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        heightInPixels\n                        widthInPixels\n                        path\n                        status {\n                          kind\n                          id\n                        }\n                      }\n                      state {\n                        kind\n                        id\n                      }\n                      topLevelMediaType {\n                        kind\n                        id\n                      }\n                    }\n                    kind\n                    link\n                  }\n                }\n              }\n            }\n            ... on Node {\n              id\n            }\n          }\n        }\n      }\n      activities {\n        kind\n        label\n        id\n      }\n      isClaimable\n      pitchOriginalMedia {\n        id\n      }\n      investmentsBy {\n        amount\n        link\n        deckUrl\n        investmentDate\n        id\n      }\n      opportunities {\n        productAndServices {\n          description\n          link\n          email\n        }\n        careers {\n          description\n          link\n          email\n        }\n        collaboration {\n          description\n          link\n          email\n        }\n        id\n      }\n      fundingRound\n      isFundraising\n      isFeedBaseEntity\n      landingPageUrl\n      locations {\n        id\n        label\n      }\n      headquarters {\n        location {\n          label\n          id\n        }\n        id\n      }\n      feed(kind: PROFILE) {\n        feed {\n          key\n          stories {\n            __typename\n            ... on RadivisionPost {\n              id\n              link\n              title\n            }\n            ... on ArticleStory {\n              id\n              link\n              kind\n              publisher\n              publishedDate\n              timeToReadInSeconds\n              previews {\n                edges {\n                  preview {\n                    link\n                    kind\n                  }\n                }\n              }\n              description\n              title\n            }\n            ... on Node {\n              id\n            }\n          }\n        }\n      }\n      mediaAbout {\n        count\n        edges {\n          cursor\n          story {\n            __typename\n            ... on RadivisionPost {\n              id\n              link\n              previews {\n                edges {\n                  cursor\n                  preview {\n                    link\n                    kind\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                    }\n                  }\n                }\n                count\n              }\n              subTitle\n              title\n              description\n              landingPageUrl\n              revision\n              content\n            }\n            ... on OnlineCourseStory {\n              id\n              publishedDate\n              timeRequiredInSeconds\n              publisher\n              link\n              previews {\n                edges {\n                  cursor\n                  preview {\n                    link\n                    kind\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n              subTitle\n              title\n              description\n              revision\n            }\n            ... on ArticleStory {\n              description\n              id\n              link\n              publisher\n              publishedDate\n              timeToReadInSeconds\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    kind\n                    mediaAsset {\n                      id\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n              revision\n              subTitle\n              title\n            }\n            ... on BookStory {\n              id\n              link\n              publisher\n              publishedDate\n              timeToReadInSeconds\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    kind\n                    mediaAsset {\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                      id\n                    }\n                  }\n                }\n              }\n              subTitle\n              title\n              description\n              revision\n            }\n            ... on NewsletterStory {\n              id\n              description\n              link\n              publisher\n              publishedDate\n              timeToReadInSeconds\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    kind\n                    mediaAsset {\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                      id\n                    }\n                  }\n                }\n              }\n              subTitle\n              title\n              revision\n            }\n            ... on PodcastStory {\n              id\n              link\n              publisher\n              publishedDate\n              durationInSeconds\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    kind\n                    mediaAsset {\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                      id\n                    }\n                  }\n                }\n              }\n              subTitle\n              title\n              description\n              revision\n            }\n            ... on OriginalContentStory {\n              id\n              durationInSeconds\n              previews {\n                count\n                edges {\n                  cursor\n                  preview {\n                    link\n                    kind\n                    mediaAsset {\n                      files {\n                        id\n                        name\n                        path\n                      }\n                      topLevelMediaType {\n                        kind\n                        label\n                        id\n                      }\n                      id\n                    }\n                  }\n                }\n              }\n              subTitle\n              title\n              revision\n            }\n            ... on Node {\n              id\n            }\n          }\n        }\n      }\n      name\n      hasPortfolio\n      portfolioMarketCap\n      portfolioEntities {\n        id\n      }\n      portfolioPeople {\n        id\n      }\n      noOfPortfolioCompanies {\n        maximum\n        minimum\n        isGreaterThan\n        isLessThan\n      }\n      portfolio {\n        count\n        pageInfo {\n          hasNextPage\n        }\n        edges {\n          edges {\n            __typename\n            id\n            name\n            landingPageUrl\n            previews(kinds: [SQUARE, LOGO]) {\n              edges {\n                preview {\n                  link\n                  mediaAsset {\n                    id\n                    files {\n                      name\n                      path\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                }\n              }\n            }\n            tags {\n              label\n              id\n            }\n          }\n        }\n      }\n      noOfEmployees {\n        maximum\n        minimum\n        isGreaterThan\n        isLessThan\n      }\n      people(first: 24) {\n        count\n        pageInfo {\n          hasNextPage\n        }\n        edges {\n          role\n          person {\n            id\n            __typename\n            fullName\n            responsibility\n            description\n            landingPageUrl\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  link\n                  kind\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      path\n                    }\n                    topLevelMediaType {\n                      kind\n                      label\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      previews {\n        count\n        edges {\n          cursor\n          preview {\n            link\n            kind\n            mediaAsset {\n              id\n              files {\n                id\n                name\n                path\n              }\n              topLevelMediaType {\n                kind\n                label\n                id\n              }\n            }\n          }\n        }\n      }\n      northStar {\n        __typename\n        description\n        id\n        questions {\n          __typename\n          ... on TextQuestion {\n            content\n            id\n            response {\n              content\n              id\n            }\n          }\n          ... on MultipleChoiceQuestion {\n            id\n          }\n        }\n      }\n      tagLine\n      mission\n      country\n      spotlights\n      socialMediaCredentials {\n        credential\n        platform {\n          kind\n          id\n        }\n        id\n      }\n      socialMediaProfiles {\n        id\n        link\n        platform {\n          id\n          kind\n        }\n      }\n      revision\n      websiteUrl\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'e82a31f41f2b8d77a379ffd483f949f0';
export default node;
